import { useNavigate } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import PmocForm from './PmocForm'
import { usePmocCreate } from '../../hooks/usePmoc'
import { extractApiError, extractApiErrorList } from '../../lib/extractApiError'
import type { PMOCCreateInput } from '../../types'
import styles from '../_shared/CrudPage.module.css'

export default function PmocNovaPage() {
  const navigate = useNavigate()
  const create = usePmocCreate()

  async function handleSubmit(data: PMOCCreateInput) {
    if (!data.cliente) {
      notifications.show({ color: 'red', message: 'Selecione um cliente.' })
      return
    }
    try {
      const novo = await create.mutateAsync(data)
      notifications.show({ color: 'green', message: `PMOC v${novo.versao} criado.` })
      navigate(`/pmoc/${novo.id}`)
    } catch (err) {
      // Backend pode retornar múltiplos erros consolidados (PR #49 — validações ricas)
      const errors = extractApiErrorList(err)
      if (errors.length > 1) {
        notifications.show({
          color: 'red',
          title: `Falha ao criar PMOC — ${errors.length} problemas`,
          message: errors.slice(0, 5).join(' • '),
          autoClose: 8000,
        })
      } else {
        notifications.show({
          color: 'red',
          title: 'Falha ao criar PMOC',
          message: extractApiError(err, 'Verifique os campos e tente novamente.'),
        })
      }
    }
  }

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <button
            className={styles.backBtn}
            type="button"
            onClick={() => navigate('/pmoc')}
          >
            ← Voltar
          </button>
          <h1 className={styles.title}>Novo PMOC</h1>
        </div>
      </header>
      <PmocForm onSubmit={handleSubmit} isLoading={create.isPending} submitLabel="Criar PMOC" />
    </div>
  )
}
